import { isEmpty } from 'lodash-es';

export const formatDigitalWalletToPayment = paymentMethodType => {
  return {
    type: paymentMethodType,
    address: null,
    fields: {},
    payment_method_options: {},
    metadata: {}
  };
};

export const extractPaymentMethodTypeToUse = ({
  paymentMethodTypes,
  paymentMethodData,
  digitalWalletProvider,
  checkForCardType = true
}) => {
  const { network, type } = paymentMethodData || {};

  const relevantPmt = paymentMethodTypes.find(pmt => {
    const {
      mapping,
      supported_digital_wallet_providers: supportedDigitalWalletProviders
    } = pmt;
    if (!mapping || isEmpty(supportedDigitalWalletProviders)) return;

    const isPmtSupportedDigitalWalletProvider = (
      supportedDigitalWalletProviders || []
    ).includes(digitalWalletProvider);
    if (!isPmtSupportedDigitalWalletProvider) return;

    return mapping.find(pmtMapping => {
      const { brand, card_types } = pmtMapping;
      return (
        brand?.toLowerCase() === network?.toLowerCase() &&
        (Boolean(checkForCardType) ||
          card_types.some(cardType =>
            ['unknown', type?.toLowerCase()].includes(cardType?.toLowerCase())
          ))
      );
    });
  });

  return relevantPmt?.type;
};

export const getSupportedPaymentMethodTypeNetworks = ({
  paymentMethodTypes,
  allowedNetworks,
  transformCallback
}) => {
  const supportedNetworks = new Set([
    ...paymentMethodTypes.flatMap(
      pmt => pmt.mapping?.map(mapping => mapping?.brand?.toLowerCase()) || []
    )
  ]);
  const filteredNetworks = Array.from(supportedNetworks).filter(network =>
    allowedNetworks.includes(network)
  );
  const transformedNetworks = transformCallback
    ? filteredNetworks.map(transformCallback)
    : filteredNetworks;
  return transformedNetworks;
};
